import React, { useEffect, useRef } from 'react';
import profile from '../assets/hilman-img.png';
import { init } from 'ityped';
import { SiGmail } from "react-icons/si";
import { SiGithub } from "react-icons/si";
import { SiLinkedin } from "react-icons/si";
import { SiHackerrank } from "react-icons/si";
import { SiInstagram } from "react-icons/si";

function Intro() {
    const textRef = useRef()

    useEffect(() => {
        init(textRef.current, { 
            showCursor: true,
            backDelay: 1500, 
            backSpeed: 100,
            strings: ['Software Developer'] 
        })
    }, []);

    return (
        <div className="bg-intro" id="intro">
            <div className="max-intro">
                <div className="right-intro">
                    <h1>HILMAN AHMAD</h1>
                    <h2>a <span ref={textRef}></span></h2>
                    <div className="intro-detail">
                        Based in Kuala Lumpur, Malaysia. I am building a website who specialise in <i><b style={{color: '#5e3aee'}}>Frontend Development</b></i>.
                    </div>
                    <div className="social-icon">
                        <SiGmail className="icons-react" onClick={() => window.open("mailto:mhilmanahmad@gmail.com")}/>
                        <SiGithub className="icons-react" onClick={() => window.open("https://github.com/hilmanmanang", "_blank")}/>
                        <SiLinkedin className="icons-react" onClick={() => window.open("https://www.linkedin.com/in/muhammad-hilman-bin-ahmad-a16011185/", "_blank")}/>
                        <SiInstagram className="icons-react" onClick={() => window.open("https://www.instagram.com/hilmanmanang/", "_blank")}/>
                        <SiHackerrank className="icons-react" onClick={() => window.open("https://www.hackerrank.com/mhilmanahmad", "_blank")}/>
                    </div>
                </div>
                <div className="left-intro">
                    <div className="round-profile-bg">
                        <img className="width-img-profile" src={profile} alt="" />
                    </div>
                </div>
            </div>
            <div className="max-intro-hr">
                <hr/>
                <div className="intro-number">
                    <div>
                        <div className="intro-number-details">10+</div>
                        <div className="intro-detail-details">PROJECTS COMPLETED</div>
                    </div>
                    <div>
                        <div className="intro-number-details">3+</div>
                        <div className="intro-detail-details">YEARS EXPERIENCE</div>
                    </div>
                    <div>
                        <div className="intro-number-details">10+</div>
                        <div className="intro-detail-details">LICENSES & CERTIFICATION</div>
                    </div>
                </div>
                <hr/>
            </div>
        </div>
    )
}

export default Intro
